<template>
  <section id="surface" class="surface" v-if="ready">
    <b-container fluid>
      <b-row class="header">
        <b-card overlay :img-src="require(`../../assets/images/surface/background.jpg`)" img-alt="Surface Food Prep Background" text-variant="white">
          <div class="aspect-ratio"></div>

          <parallax id="surfer"><b-img fluid :src="require(`../../assets/images/surface/bacteria.png`)"></b-img></parallax>

          <b-card-text class="headline">
            <h1 v-bind:class="{ blur: blurheadline }">A Food safety campaign that sees beyond the <br /><span>Surface</span></h1>
          </b-card-text>

          <b-row class="main-row">
            <b-col class="main-info">
              <b-card-text class="info-container">
                <h2>Turning data into action.</h2>
                <p>When it comes to monitoring our food supply, 3M is always one step ahead of the technological curve. But how do you get the latest, greatest safeguards that science has to offer into the hands of those on the front lines? With powerful new systems, comes the great responsibility to generate awareness and encourage education by trial.</p>
              </b-card-text>
            </b-col>
          </b-row>
        </b-card>
      </b-row>

      <div class="row speed">
        <div class="col content" data-aos="fade-right">
          <h3>
            accurate bacteria detection with <br />
            <span>speed</span>
          </h3>
          <p>Our approach was to craft a message that spoke directly to those working behind the scenes protecting the public from potential bacterial contamination in the food processing industry. Those monitoring the lines, need the ability to get results quickly, and act on those results with complete confidence. Anything less can result in significant and unnecessary losses. The program we developed was released as “The speed and accuracy you need when it’s all on the line.”</p>
        </div>

        <b-img data-aos="fade-left" fluid :src="require(`../../assets/images/surface/FoodSafety-swab.png`)"></b-img>
      </div>

      <div class="row devices" data-aos="fade-down">
        <div class="col content">
          <b-img class="bacteriaone" fluid :src="require(`../../assets/images/surface/bacteria1.png`)"></b-img>

          <b-img fluid :src="require(`../../assets/images/surface/foodSafety-devices.png`)"></b-img>
        </div>
      </div>

      <div class="row traffic">
        <div class="col-12">
          <h3>Driving traffic to trials.</h3>
        </div>
        <div class="col-md-6">
          <p>Given the technical nature and components involved with the 3M™ Clean-Trace™ monitoring system, we initially connected with our audience online. Following the launch announcement, new features, upgrades, and advancements were released along with a visually engaging video to attract further interest. An incentive program was layered on top of the awareness campaign to boost traffic to the launch website where visitors</p>
        </div>
        <div class="col-md-6">
          <p>were able to sign up for a trial run of the Clean-Trace™ Luminometer unit and accompanying software package and experience the difference first-hand.</p>
          <p>With literally so much on the line, 3M’s trial demonstration strategy proved to be effective at getting the new Clean-Trace™ Hygiene Monitoring & Management System into the right hands – and keeping it there.</p>
        </div>
      </div>

      <b-card class="footer" overlay :img-src="require(`../../assets/images/surface/foodSafety-video.png`)" img-alt="Surface Food Prep Background" text-variant="white">
        <div class="row touchpoints">
          <b-img class="bacteriatwo" fluid :src="require(`../../assets/images/surface/bacteria2.png`)"></b-img>
          <div class="col-md-6 bannerbung" data-aos="fade-right">
            <b-img fluid :src="require(`../../assets/images/surface/foodSafety-bannerBugs.png`)"></b-img>
          </div>
          <div class="col-md-6 content">
            <div class="text">
              <h3>Traditional touchpoints.</h3>
              <p>With a multi-pronged approach, 3M representatives set out to hit the trade show circuit and in-person consultations equipped with traditional sales collateral in the form of pop-up displays, brochures and leave-behinds with additional awareness support from a direct mail campaign. With a cohesive message and consistent design, the integrated aspects of the campaign came together as one.</p>
            </div>
            <b-img data-aos="fade-left" fluid :src="require(`../../assets/images/surface/foodSafety-print.png`)"></b-img>
          </div>
        </div>

        <div class="row volume">
          <div class="col-lg-6 offset-lg-6 col-md-8 offset-md-4 video-content">
            <h3>Video speaks volumes.</h3>
            <p>Our video production and 3D animation team developed a campaign video to help draw additional attention and traffic to the website. This final asset brought the campaign to life with smooth motion and crisp CG elements highlighting all the new Clean-Trace™ monitoring system features in an intuitive, compelling, and engaging fashion.</p>
            <b-img class="clickme" fluid @click="$bvModal.show('modal-footer-lg')" :src="require(`../../assets/images/surface/detect-video.png`)"></b-img>
          </div>
        </div>
      </b-card>

      <b-modal id="modal-footer-lg" size="xl" centered modal-cancel="dude">
        <div class="modal-body-full">
          <iframe src="https://player.vimeo.com/video/938597321?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&title=0&byline=0&portrait=0&share=0" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" style="width:100%;height:100%;" title="Trade In Trade Up Instructional Video"></iframe>
        </div>
      </b-modal>
    </b-container>

    <div class="container-fluid otherwork" :class="{ 'section-animation-in': hover }">
      <h4>See work <span>that matters.</span></h4>

      <div class="preview-text-container" @click="toggleActive" :class="{ 'additional-class': activeStates[0] }">
        <div class="image-container">
          <div class="divide"></div>
          <router-link to="/work/universe" class="content">
            <span class="projecttype dark">APP DEVELOPMENT</span>
            <span class="otherprojecthead dark">Unilux VFC</span>
            <span class="changeme dark">Control your universe.</span>
          </router-link>

          <img class="fade-in-image" :src="require(`../../assets/images/universe-other.png`)" alt="Your image" />
        </div>
      </div>

      <div class="preview-text-container" @click="toggleActive" :class="{ 'additional-class': activeStates[1] }">
        <div class="image-container">
          <div class="divide"></div>
          <router-link to="/work/winning" class="content">
            <span class="projecttype">CAMPAIGN DEVELOPMENT</span>
            <span class="otherprojecthead">3M Electrical</span>
            <span class="changeme">Uncover the secret.</span>
          </router-link>

          <img class="fade-in-image" :src="require(`../../assets/images/winning-other.png`)" alt="Your image" />
        </div>
      </div>

      <div class="preview-text-container" @click="toggleActive" :class="{ 'additional-class': activeStates[2] }">
        <div class="image-container">
          <div class="divide"></div>
          <router-link to="/work/clarity" class="content">
            <span class="projecttype">CAMPAIGN DEVELOPMENT</span>
            <span class="otherprojecthead">3M Clarity</span>
            <span class="changeme">Smiles for miles.</span>
          </router-link>

          <img class="fade-in-image" :src="require(`../../assets/images/clarity-other.png`)" alt="Your image" />
        </div>
      </div>

      <div class="preview-text-container" @click="toggleActive" :class="{ 'additional-class': activeStates[3] }">
        <div class="image-container">
          <div class="divide"></div>
          <router-link to="/work/higher" class="content">
            <span class="projecttype">CAMPAIGN DEVELOPMENT</span>
            <span class="otherprojecthead">3M Fall Protection</span>
            <span class="changeme">Bottom lines to new heights.</span>
          </router-link>
          <img class="fade-in-image" :src="require(`../../assets/images/higher-other.png`)" alt="Your image" />
        </div>
      </div>

      <div class="preview-text-container" @click="toggleActive" :class="{ 'additional-class': activeStates[4] }">
        <div class="image-container">
          <div class="divide"></div>
          <router-link to="/work/prepack-planner" class="content">
            <span class="projecttype">APP DEVELOPMENT</span>
            <span class="otherprojecthead">McCormick Display Strategy</span>
            <span class="changeme">Displays to order.</span>
          </router-link>

          <img class="fade-in-image" :src="require(`../../assets/images/prepack-other.png`)" alt="Your image" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Parallax from "vue-parallaxy";

//AOS Animations
import AOS from "aos";
import "aos/dist/aos.css";

export default {
  components: {
    Parallax,
  },
  data() {
    return {
      hover: false,
      ready: false,
      blurheadline: false,
      isActive: false,
      activeStates: {},
    };
  },
  metaInfo: {
    titleTemplate: "A Food Safety Campaign that Sees Beyond the Suface | Branton  — a Creation Company.",
    meta: [
      {
        name: "Our Work",
        content: "3M’s Food Safety Campaign, turning data into action. created by Branton. The speed and accuracy you need when it’s all on the line. ",
      },
    ],
  },
  methods: {
    initializeObservers() {
      const elements = this.$el.querySelectorAll(".preview-text-container");
      if (elements.length === 0) {
        console.error("No elements found");
        return;
      }
      elements.forEach((element, index) => {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              console.log(`Element ${index} is intersecting: ${entry.isIntersecting}`);
              this.$set(this.activeStates, index, entry.isIntersecting);
            });
          },
          { threshold: 1 }
        );

        observer.observe(element);
      });
    },

    handleScroll() {
      if (window.scrollY > 200) {
        this.blurheadline = true;
      } else {
        this.blurheadline = false;
      }
    },
    toggleActive(event) {
      event.currentTarget.classList.toggle("active");
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initializeObservers();
    });

    this.ready = true;

    this.$gtag.pageview({
      page_path: "/work/surface",
    });

    if (this.ready) {
      AOS.init();
      AOS.refresh();
      setTimeout(
        function() {
          AOS.refresh();
        }.bind(this),
        300
      );
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="scss">
@import "@/assets/css/surface.scss";

div#surfer {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 100;
  user-select: none; /* Prevents selection of image content */
  -webkit-user-select: none; /* Safari specific prefix */
  pointer-events: none; /* Prevents mouse events on the image */
}

#surface {
  &.surface {
    h1,
    p,
    h2,
    h3 {
      color: #4a4f54;
    }
    background: white;
  }
}
</style>
